import React from 'react';
import classnames from 'classnames';
import s from './TextTooltipContent.scss';
const SHORT_CONTENT_THRESHOLD = 30;
/** @deprecated */ const TextTooltipContent = ({ textClassName, title, tooltipText })=>{
    const isShortContent = typeof tooltipText === 'string' && tooltipText.length <= SHORT_CONTENT_THRESHOLD;
    const alignment = isShortContent && 'center' || undefined;
    return /*#__PURE__*/ React.createElement("div", {
        className: s['wrapper']
    }, title && /*#__PURE__*/ React.createElement("div", {
        className: s['title']
    }, title), /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['text'], alignment && s[`align-${alignment}`], textClassName)
    }, tooltipText));
};
export default TextTooltipContent;

//# sourceMappingURL=TextTooltipContent.js.map